/* import __COLOCATED_TEMPLATE__ from './user-select.hbs'; */
import { sanitized } from 'volta/utils/text-utils';

import { action } from '@ember/object';
import Component from '@glimmer/component';

import type User from 'volta/models/user';

interface UserSelectSignature {
  Args: {
    afterOptionsComponent: unknown;
    disabled: unknown;
    fill: unknown;
    isLoading: unknown;
    isRequired: unknown;
    matchTriggerWidth: unknown;
    multiple: unknown;
    onChange: unknown;
    onOpen: unknown;
    options: unknown;
    placeholder: unknown;
    searchField: unknown;
    selected: unknown;
    size: unknown;
    triggerClass: unknown;
  };
  Element: HTMLElement;
}

export default class UserSelectComponent extends Component<UserSelectSignature> {
  @action
  matchName(person: User, term: string) {
    return `${sanitized(person.firstName)} ${sanitized(person.middleName)} ${sanitized(
      person.lastName
    )} ${sanitized(person.login)} ${sanitized(person.email)}`.includes(sanitized(term))
      ? 1
      : -1;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    UserSelect: typeof UserSelectComponent;
    'user-select': typeof UserSelectComponent;
  }
}
